import { ApiError } from '~/_v3/common/actors/errors';
import { removeAllTokens } from '~/_v3/composables/useToken';
import { router } from '~/router';

const baseUrl = import.meta.env.SILAE_EDP_BACKEND_URL;

export const isAuthTokenNotValid = responseBody =>
	responseBody.errors && responseBody.errors.find(error => error.code === 'AuthTokenNotValid');

// Utility function to handle API requests
export const apiRequest = async (
	url: string,
	method: 'GET' | 'POST' | 'PUT' | 'DELETE',
	token?: string | null,
	data?: any,
	customHeaders?: any
) => {
	const headers = new Headers(
		customHeaders
			? customHeaders
			: {
					Accept: 'application/json',
					Authorization: token ? 'Bearer ' + token : ''
				}
	);

	// Only set Content-Type if not FormData
	if (!(data instanceof FormData)) {
		headers.set('Content-Type', 'application/json');
	}
	const response = await fetch(`${baseUrl}${url}`, {
		method,
		headers,
		body: data ? (data instanceof FormData ? data : JSON.stringify(data)) : undefined
	});

	let responseBody: any;

	try {
		// Try to parse as JSON
		responseBody = await response.json();
	} catch (jsonError) {
		// If JSON parsing fails, try to read as text
		try {
			const text = await response.text();
			responseBody = text || null; // If it's an empty string, return null
		} catch (textError) {
			// Total failure — no usable body
			responseBody = null;
		}
	}

	if (!response.ok) {
		if (isAuthTokenNotValid(responseBody)) {
			removeAllTokens();
			router.push({ name: 'login' });
		}
		throw new ApiError(`HTTP error! Status: ${response.status}`, responseBody);
	}

	return responseBody;
};

export const downloadRequest = async (url: string, method: 'GET' | 'POST', token?: string | null, data?: any) => {
	const response = await fetch(`${baseUrl}${url}`, {
		method,
		headers: new Headers({
			Accept: 'application/octet-stream',
			'Content-Type': 'application/json',
			Authorization: token ? 'Bearer ' + token : ''
		}),
		body: data ? JSON.stringify(data) : undefined
	});

	let responseBody: any;

	console.log(response);

	if (!response.ok) {
		try {
			responseBody = await response.clone().json();
		} catch {
			responseBody = await response.text(); // fallback
		}

		if (isAuthTokenNotValid(responseBody)) {
			removeAllTokens();
			router.push({ name: 'login' });
		}

		throw new ApiError(`HTTP error! Status: ${response.status}`, responseBody);
	}

	const blob = await response.blob();

	console.log(blob);
	const contentDisposition = response.headers.get('Content-Disposition');

	return { blob, contentDisposition };
};
